import _ from 'lodash'

const ENTITIES: Record<string, string> = {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;'}

export function escapeHtml(value: string): string {
    return value.replace(/[&<>"']/g, (char) => ENTITIES[char])
}

/** Escapes every string in plain objects and arrays; other values (numbers, dates, moments) are returned as is. */
export function escapeHtmlDeep<T>(value: T): T {
    if (typeof value === 'string') {
        return escapeHtml(value) as T
    }

    if (Array.isArray(value)) {
        return value.map((item) => escapeHtmlDeep(item)) as T
    }

    if (_.isPlainObject(value)) {
        return _.mapValues(value as object, (item) => escapeHtmlDeep(item)) as T
    }

    return value
}

/**
 * Wraps an email template so every value it gets is HTML-escaped before it is interpolated. Keys in `raw` are passed
 * through as is: the reseller's own email text (`message`), whose placeholder values are already escaped in mail.ts.
 */
export function escapedTemplate<A extends object, R extends unknown[], T>(template: (data: A, ...rest: R) => T, raw: string[] = ['message']) {
    return (data: A, ...rest: R): T => {
        const escaped = escapeHtmlDeep(_.omit(data, raw)) as A
        return template({...escaped, ..._.pick(data, raw)} as A, ...rest)
    }
}
